/**
 * Chat Route Access Error
 *
 * Typed errors for protected chat route access failures.
 *
 * Primary responsibilities:
 * - Preserve auth failures separately from missing chats
 * - Let chat UI choose recovery instead of rendering a false 404
 *
 * Dependencies:
 * - None
 */

export class ChatRouteAuthError extends Error {
  readonly status = 401

  constructor(message = 'Authentication required') {
    super(message)
    this.name = 'ChatRouteAuthError'
  }
}

// --------------

export class ChatRouteForbiddenError extends Error {
  readonly status = 403

  constructor(message = 'Chat access denied') {
    super(message)
    this.name = 'ChatRouteForbiddenError'
  }
}

// --------------

export function isChatRouteAuthError(error: unknown): error is ChatRouteAuthError {
  return error instanceof ChatRouteAuthError
}

// --------------

export function isChatRouteForbiddenError(
  error: unknown
): error is ChatRouteForbiddenError {
  return error instanceof ChatRouteForbiddenError
}
